module.exports = __webpack_public_path__ + "img/军兵种.b3eea978.png";